<template>
  
  <Tabs :active="Number(activeId)" class="tabs" @change="change">
    <Tab :title="$t('login.account_password_login')" :name="1" key="1" />
    <Tab v-if="!showOnlyPassword" :title="$t('login.message_login_text')" :name="2" key="2" />
  </Tabs>
</template>

<script>
import { Tabs, Tab } from "vant"
export default {
  components: {
    Tabs, Tab
  },
  props: {
    activeId: {
      type: [String, Number],
      default: 1
    },
    showOnlyPassword: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    change(id){
      this.$emit("change", id);
    }
  }
}
</script>

<style scoped lang="less">
  .tabs{
    margin-top: 20px;
    display: flex;
    position: relative;
    ::v-deep .van-tabs__nav{
      background-color: rgba(0,0,0,0);
    }
    ::v-deep .van-tab{
      width: auto;
      .van-tab__text--ellipsis{
        white-space: nowrap;
      }
      &:nth-child(1){
        margin-left: 0;
      }
      font-size: 32px;
      margin-left: 50px;
      color: #A2A2A2;
      line-height: 80px;
      position: relative;
      font-weight: 500;
      padding: 0;
      &.van-tab--active{
        color: #17161C;
        font-weight: 600;
      }
    }
    ::v-deep .van-tabs__line{
      width: 60px;
      height: 4px;
      background: #0F0F2F;
      border-radius: 8px;
    }
  }
</style>
